import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router'; // Import useRouter
import { useMutation } from 'react-query';
import { SurveyCertificate } from 'services/survey';
import { SurveyQuestionTypes } from 'constants/Survey';

import SurveyQuestion from '@core/components/surveyquestion/SurveyQuestion';

import classes from './Survey.module.scss';

const Survey = ({ survey, setSurveyStatus }) => {
    const router = useRouter();
    const courseId = router.query.slug[0];
    const [activePage, setActivePage] = useState(1);
    const [responses, setResponses] = useState({}); // State to store user responses
    const { mutate } = useMutation(SurveyCertificate.POST);

    const submitQuestion = (questionId, answer, type) => {
        setResponses((prev) => ({
            ...prev,
            [parseInt(questionId)]: (type === SurveyQuestionTypes.TEXT || type === SurveyQuestionTypes.NUMBER)
                ? { choices_answer: null, text_answer: answer }
                : { choices_answer: answer, text_answer: null },
        }));
        setActivePage((prev) => prev + 1);
    };

    useEffect(() => {
        if (activePage > survey.questions.length) {
            setSurveyStatus(false);
            const formattedResponses = {
                id: survey.id, // Assuming survey has an `id` property
                questions: Object.entries(responses).map(([questionId, answerObj]) => ({
                    id: parseInt(questionId),
                    choices_answer: answerObj.choices_answer,
                    text_answer: answerObj.text_answer,
                })),
            };
            mutate({ id: courseId, payload: formattedResponses  }); // Use courseId from state
        }
    }, [activePage]);

    return (
        <div className={classes['wrapper']}>
            <h3>Your Input is valuable to us</h3>
            <p>Before downloading your certificate, please answer {survey.questions.length} questions to help Pharmuni</p>
            <span className={classes['question-number']}>{activePage}/{survey.questions.length}</span>
            {survey.questions.map((question, index) => {
                if (index + 1 === activePage) {
                    return (
                        <SurveyQuestion
                            key={question.id}
                            question={question}
                            submitQuestion={(answer) => submitQuestion(question.id, answer, question.type)}
                        />
                    );
                }
                return null;
            })}
        </div>
    );
};

export default Survey;